import axios from 'redaxios'

/**
 * HTTP request composable.
 *
 * @param {import('vue').Ref} flashRef  — optional ref to a FlashNotifications component.
 *   Pass the template ref so axiosRequest can call flashRef.value.show() on success/error.
 *   In <script setup>: const flash = ref(null); const { axiosRequest } = useRequest(flash)
 *   Then in template: <FlashNotifications ref="flash" />
 */
export function useRequest(flashRef = null) {
  function getRequestHeaders(data) {
    const headers = {
      'X-CSRF-TOKEN': document.querySelector('[name="csrf-token"]').getAttribute('content'),
    }
    // Let the browser set Content-Type (including the multipart boundary) when
    // sending FormData. For everything else, default to JSON.
    if (!(data instanceof FormData)) {
      headers['Content-Type'] = 'application/json'
    }
    return headers
  }

  async function axiosRequest(type, url, data, showNotifications = true) {
    try {
      const headers = getRequestHeaders(data)
      let response = {}
      if (type === 'GET') response = await axios.get(url, { headers })
      else if (type === 'POST') response = await axios.post(url, data, { headers })
      else if (type === 'PUT') response = await axios.put(url, data, { headers })
      else if (type === 'PATCH') response = await axios.patch(url, data, { headers })
      else if (type === 'DELETE') response = await axios.delete(url, { headers, data })

      if (showNotifications && flashRef?.value) {
        const msg = response.data.success ? response.data.message : response.data.error
        const type = response.data.success ? 'notice' : 'alert'
        flashRef.value.show(msg, type)
      }
      return { js_error: false, response: response.data }
    } catch (error) {
      if (showNotifications && flashRef?.value) {
        flashRef.value.show('Something went wrong. Please try again.', 'alert')
      }
      console.log(error)
      return { js_error: true, error }
    }
  }

  async function fetchCurrentUser() {
    const res = await axiosRequest('GET', '/api/v1/user', {}, false)
    return (!res.js_error && res.response.success) ? res.response.data : {}
  }

  return { getRequestHeaders, axiosRequest, fetchCurrentUser }
}
